import { DEVICE_UUID } from '../core/config.js';
import { lwDispatch } from '../core/livewire.js';
import { isTransientIdbError } from '../data/idb.js';

export const Sync = {
    async pushUnsynced(db) {
        try {
            const all = await db.getAll('badges');
            for (const b of all) {
                const hasPending = Array.isArray(b.local_scan_logs) && b.local_scan_logs.some(l => l?.local_scan === true);
                if (!b.synced || hasPending) await this.pushOne(b);
            }
        } catch (err) {
            if (!isTransientIdbError(err)) throw err;
        }
    },

    async pushOne(badge) {
        if (!navigator.onLine) return;

        const pendingLogs = (Array.isArray(badge.local_scan_logs) ? badge.local_scan_logs : [])
            .filter(l => l?.local_scan === true)
            .map(l => ({
                created_at_ts: l.created_at_ts,
                local_scan: true,
                validated_from: l.validated_from
            }))
            .filter(l => l.created_at_ts != null);

        if (!pendingLogs.length) return;

        lwDispatch('checkin.badge.sync', {
            local_badge: { uuid: badge.uuid, local_scan_logs: pendingLogs, device_uuid: DEVICE_UUID },
        });
    },

    async pullDelta(db) {
        if (!navigator.onLine) return;
        const local = await db.getAll('badges');
        lwDispatch('checkin.badges.delta.fetch', { local_badges_uuids: local.map(b => b.uuid) });
    }
};